/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventsModelsAddress
 */
export interface EventsModelsAddress {
    /**
     * 
     * @type {string}
     * @memberof EventsModelsAddress
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof EventsModelsAddress
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof EventsModelsAddress
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof EventsModelsAddress
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof EventsModelsAddress
     */
    town: string;
    /**
     * 
     * @type {string}
     * @memberof EventsModelsAddress
     */
    route: string;
    /**
     * 
     * @type {string}
     * @memberof EventsModelsAddress
     */
    streetAddress: string;
    /**
     * 
     * @type {string}
     * @memberof EventsModelsAddress
     */
    lang: string;
}

export function EventsModelsAddressFromJSON(json: any): EventsModelsAddress {
    return EventsModelsAddressFromJSONTyped(json, false);
}

export function EventsModelsAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventsModelsAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
        'postalCode': json['postalCode'],
        'countryCode': json['countryCode'],
        'country': json['country'],
        'town': json['town'],
        'route': json['route'],
        'streetAddress': json['street_address'],
        'lang': json['lang'],
    };
}

export function EventsModelsAddressToJSON(value?: EventsModelsAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'postalCode': value.postalCode,
        'countryCode': value.countryCode,
        'country': value.country,
        'town': value.town,
        'route': value.route,
        'street_address': value.streetAddress,
        'lang': value.lang,
    };
}


